const Elements = {
    "fire": {
        "key": "fire",
        "name": "Fire",
        "strengths": ["earth"],
        "weaknesses": ["water"],
        "color": "#d54b33",
        // "color": "#FFA0AC",
    },
    "earth": {
        "key": "earth",
        "name": "Earth",
        "strengths": ["water"],
        "weaknesses": ["fire"],
        "color": "#62C370",
        // "color": "#6D466B",
    },
    "water": {
        "key": "water",
        "name": "Water",
        "strengths": ["fire"],
        "weaknesses": ["earth"],
        "color": "#639bff",
        // "color": "#F2CC8F",
    },
    "light": {
        "key": "light",
        "name": "Light",
        "strengths": ["dark"],
        "weaknesses": ["dark"],
        "color": "#F2CC8F",
    },
    "dark": {
        "key": "dark",
        "name": "Dark",
        "strengths": ["light"],
        "weaknesses": ["light"],
        "color": "#6D466B",
    },
    undefined: {
        "key": undefined,
        "name": "Null",
        "strengths": [],
        "weaknesses": [],
        "color": "gray"
    }
}

Elements.getEffectiveness = function(defensiveElements, offensiveElements) {
    defensiveElements = defensiveElements instanceof Array ? defensiveElements : [defensiveElements]
    offensiveElements = offensiveElements instanceof Array ? offensiveElements : [offensiveElements]

    if(Elements[offensiveElements[0]] == undefined) {
        return 0
    }
    if(Elements[offensiveElements[0]].strengths.includes(defensiveElements[0])) {
        return +1
    }
    if(Elements[offensiveElements[0]].weaknesses.includes(defensiveElements[0])) {
        return -1
    }
    return 0
}

Elements.getDamage = function(defensiveElements, offensiveElements, potency) {
    const effectiveness = Elements.getEffectiveness(defensiveElements, offensiveElements)

    if(potency == "mad") {
        if(effectiveness < 0) return +2
        if(effectiveness > 0) return -2
        return 0
    }
    if(potency == "mild") {
        if(effectiveness < 0) return +1
        if(effectiveness > 0) return -1
        return 0
    }

    // potency == "standard"
    if(effectiveness < 0) return 0 // +0.5
    if(effectiveness > 0) return -1
    return 0
}

export default Elements
